import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

export type ChatButtonState =
  | 'default'
  | 'hover'
  | 'disabled'
  | 'unavailable'
  | 'connection-lost'
  | 'focus-visible';

export type ChatButtonType = 'default' | 'minimized';

const CONNECTIONLOST = 'connection-lost';
const CONNECTIONUNAVAILABLE = 'unavailable';

@Component({
  selector: 'app-chat-button-open',
  templateUrl: './chat-button-open.component.html',
  styleUrls: ['./chat-button-open.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatButtonOpenComponent {
  @Input() state: ChatButtonState = 'default';
  @Input() type: ChatButtonType = 'default';
  @Output() clicked = new EventEmitter<void>();

  protected isHovered = false;

  @HostBinding('class') get hostClasses(): string {
    return `state-${this.state} type-${this.type}`;
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.isHovered = true;
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.isHovered = false;
  }

  get iconName(): string {
    if (this.state === CONNECTIONLOST) {
      return 'sync';
    }
    return 'chat';
  }

  get label(): string {
    if (this.state === CONNECTIONLOST) {
      return 'Reconnecting';
    }
    if (this.state === CONNECTIONUNAVAILABLE) {
      return 'Unavailable';
    }
    return 'Need help?';
  }

  get isInteractionBlocked(): boolean {
    return (
      this.state === 'disabled' ||
      this.state === CONNECTIONUNAVAILABLE ||
      this.state === CONNECTIONLOST
    );
  }

  get showLabel(): boolean {
    return this.type !== 'minimized';
  }
}
